import {InputLabel, Link} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";

export default function FileLink({fileName, fileUrl}) {

    return <>
        {
            !!fileName ?
                <div>
                    <InputLabel
                        id="filled-start-adornment"
                        style={{fontSize: '14px'}}>
                        <Link href={fileUrl} target='_blank'>
                            {fileName}
                        </Link>
                    </InputLabel>
                </div> :
                <div>
                    <Typography
                        variant="caption"
                        style={{fontSize: '14px', color: 'rgba(0, 0, 0, 0.6)'}}>
                        None
                    </Typography>
                </div>
        }
    </>;
}
